import { render, staticRenderFns } from "./InstallList.vue?vue&type=template&id=6ff9df47&scoped=true&"
import script from "./InstallList.vue?vue&type=script&lang=ts&"
export * from "./InstallList.vue?vue&type=script&lang=ts&"
import style0 from "./InstallList.vue?vue&type=style&index=0&id=6ff9df47&prod&scoped=true&lang=css&"
import style1 from "./InstallList.vue?vue&type=style&index=1&id=6ff9df47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9df47",
  null
  
)

export default component.exports